<template>
  <article>
    <blockquote class="block px-5 py-3 max-w-lg border-l-2 border-app-lime">
      <p class="inline-block mb-6 font-serif text-xl not-italic font-bold md:mb-12">&#8220;{{ quote }}&#8220;</p>
      <footer class="flex">
        <MoleculePicture :image="image" class="mr-3" img-class="rounded" />
        <div class="hidden md:block">
          <div class="font-bold leading-3">
            {{ source }}
          </div>
          <div>- {{ role }}</div>
        </div>
        <div class="block flex place-content-center md:hidden" :class="{ 'flex-row': !image, 'flex-col text-sm': image }">
          <div class="flex mr-1 font-bold leading-3">
            {{ source }}
          </div>
          <div class="flex leading-3">- {{ role }}</div>
        </div>
      </footer>
    </blockquote>
  </article>
</template>

<script setup lang="ts">
interface Props {
  source: string
  quote: string
  role?: string
  image?: object // Image object type is assumed here
}

defineProps<Props>()
</script>
